// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Metric.css
// module id = ./src/components/Metric.css
// module chunks = 0